import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

// Phone-sized viewport (below the 'sm' breakpoint). Used to switch dialogs
// to fullScreen and swap dense desktop layouts for stacked ones.
const useIsMobile = () => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('sm'));
};

export default useIsMobile;
